import { combineReducers } from 'redux';
import * as types from "../types";

import formReducer from './formReducer';
import requestReducer from './requestReducer';
import authReducer from './authReducer';
import popoutReducer from './popoutReducer';
import userReducer from "./userReducer";

const appReducer = combineReducers(Object.assign({}, {
    formReducer,
    requestReducer,
    authReducer,
    popoutReducer,
    userReducer
}));

const reducer = (state, action) => {
    if (action.type === types.LOGOUT) {
        state = undefined;
    }

    return appReducer(state, action);
};

export default reducer;